import { combineReducers } from "@reduxjs/toolkit"
import modalReducer from "./modalReducer";
import userReducer from "./userReducer";
import notificationReducer from "./notificationReducer";
import snackBarReducer from "./snackbarReducer";
import oscillaReducer from "./oscillaReducer";
import loadingReducer from "./loadingReducer";

const rootReducer = combineReducers({
    user: userReducer,
    modal: modalReducer,
    notifications: notificationReducer,
    oscilla: oscillaReducer,
    snackBar: snackBarReducer,
    loading: loadingReducer
})
export default rootReducer;